export default "__VITE_ASSET__e8c3aae6__"